import { Component } from '@angular/core';
import { UserService } from '../../core/user/user.service';

interface ExploreItem {
  icon: string;
  label: string;
  description: string;
  route: string;
  section: string;
  isNew?: boolean;
  isPremium?: boolean;
  hasBorderBottom?: boolean;
  image?: string;
}

@Component({
  selector: 'rosie-keep-exploring',
  templateUrl: './keep-exploring.component.html',
  styleUrls: ['./keep-exploring.component.scss'],
  standalone: false
})
export class KeepExploringComponent {
  constructor(private user: UserService) {}

  get items(): ExploreItem[] {
    return this.user.hasCommerceApp ? this.shopifyItems : this.defaultItems;
  }

  private shopifyItems: ExploreItem[] = [
    {
      icon: 'heroShoppingBag',
      label: 'Shopify settings',
      description: 'Manage which Shopify features Rosie can use on calls — draft orders, order lookups, returns, and more.',
      route: '/settings',
      section: 'commerce',
      hasBorderBottom: true
    },
    {
      icon: 'heroQuestionMarkCircle',
      label: 'FAQs',
      description: 'Add anything else you want Rosie to know beyond what we already pull from your Shopify store.',
      route: '/settings',
      section: 'faqs',
      hasBorderBottom: true
    },
    {
      icon: 'heroPencilSquare',
      label: 'Customize message taking',
      description: 'Set specific questions for Rosie to collect when taking a message.',
      route: '/settings',
      section: 'message',
      hasBorderBottom: true
    },
    {
      icon: 'heroLink',
      label: 'Text links or info to callers',
      description: 'Send links like your return policy, account login page, and more.',
      route: '/settings',
      section: 'text',
      isPremium: true,
      hasBorderBottom: true
    },
    {
      icon: 'heroPhoneArrowUpRight',
      label: 'Transfer calls to the right person or team.',
      description: 'Set up call transfers to route conversations appropriately.',
      route: '/settings',
      section: 'calls',
      isPremium: true,
      hasBorderBottom: true
    },
    {
      icon: 'heroChatBubbleLeftRight',
      label: 'Website Widgets',
      description: 'Add Rosie to your website. Choose between classic web chat or website texting.',
      route: '/settings',
      section: 'website-widgets',
      hasBorderBottom: false,
      image: 'assets/images/sms-illustration.svg'
    }
  ];

  private defaultItems: ExploreItem[] = [
    {
      icon: 'heroChatBubbleLeftRight',
      label: 'Website Widgets',
      description: 'Add Rosie to your website. Choose between classic web chat or website texting.',
      route: '/settings',
      section: 'website-widgets',
      hasBorderBottom: true,
      image: 'assets/images/sms-illustration.svg'
    },
    {
      icon: 'heroPencilSquare',
      label: 'Customize what gets asked when taking a message.',
      description: 'Set specific questions to collect the right info from callers.',
      route: '/settings',
      section: 'message',
      hasBorderBottom: true
    },
    {
      icon: 'heroLink',
      label: 'Text links or info to callers',
      description: 'Send links like price lists, menus, or forms during calls.',
      route: '/settings',
      section: 'text',
      isPremium: true,
      hasBorderBottom: true
    },
    {
      icon: 'heroPhoneArrowUpRight',
      label: 'Transfer calls to the right person or team.',
      description: 'Set up call transfers to route conversations appropriately.',
      route: '/settings',
      section: 'calls',
      isPremium: true,
      hasBorderBottom: true
    },
    {
      icon: 'heroCalendarDateRange',
      label: 'Book appointments',
      description: 'Schedule directly or send your appointment booking link during the call to book appointments on the spot.',
      route: '/settings',
      section: 'appointments',
      isPremium: true,
      hasBorderBottom: false
    }
  ];
}
